import { Link } from "wouter";
import { servicesData } from "@/data/services";
import logoImg from "@assets/1000018485_1776909210457.png";
import { Instagram } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function SiteFooter() {
  return (
    <footer className="bg-[#0A0F1C] text-slate-400 py-16 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          
          <div className="lg:col-span-2">
            <Link href="/" className="flex items-center gap-3 mb-6">
              <img src={logoImg} width={32} height={32} alt="" loading="lazy" decoding="async" className="h-8 w-8 object-contain grayscale brightness-200" />
              <span className="font-display font-bold text-xl text-white tracking-tight">All In Solutions</span>
            </Link>
            <p className="text-sm mb-6 max-w-sm leading-relaxed">
              Your trusted destination for premium print and marketing procurement. We handle the complexity so you can focus on your business.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/allinsolutionsau?igsi=MzFnMjVhODE3eXY2"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow All In Solutions on Instagram"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h2 className="text-white font-bold mb-4">Quick Links</h2>
            <ul className="space-y-3 text-sm">
              <li><Link href="/" className="hover:text-blue-500 transition-colors">Home</Link></li>
              <li><Link href="/catalogue/" className="hover:text-blue-500 transition-colors">Catalogue</Link></li>
              <li><a href="/#why-us" className="hover:text-blue-500 transition-colors">About Us</a></li>
              <li><a href="/#industries" className="hover:text-blue-500 transition-colors">Industries</a></li>
            </ul>
          </div>

          <div>
            <h2 className="text-white font-bold mb-4">Services</h2>
            <ul className="space-y-3 text-sm">
              {servicesData.slice(0, 4).map(s => (
                 <li key={s.slug}><Link href={`/services/${s.slug}/`} className="hover:text-blue-500 transition-colors">{s.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-white font-bold mb-4">Contact</h2>
            <ul className="space-y-3 text-sm">
              <li>Brisbane, QLD Australia</li>
              <li>info@allinsolutions.com.au</li>
              <li><a href="tel:+61451000000" onClick={() => trackEvent("contact_phone_clicked", { source: "footer" })} className="hover:text-white transition-colors">0451000000</a></li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© {new Date().getFullYear()} All In Solutions. All Rights Reserved.</p>
          <div className="flex gap-6">
            <span className="hover:text-white cursor-pointer transition-colors">Privacy Policy</span>
            <span className="hover:text-white cursor-pointer transition-colors">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
